/**
 * FILE: packages/utils/src/phone.ts
 * PURPOSE: Shared business utility.
 * AGENT_CONTEXT: Pure functions. No React, no Supabase client imports.
 * LAST_REVIEWED: 2026-05-07
 */

export function cleanPhone(raw: string): string {
  let cleaned = raw.replace(/[^0-9]/g, '')
  if (cleaned.length === 12 && cleaned.startsWith('91')) cleaned = cleaned.slice(2)
  if (cleaned.length === 11 && cleaned.startsWith('0')) cleaned = cleaned.slice(1)
  return cleaned.length === 10 ? cleaned : ''
}

export function validatePhone(phone: string): boolean {
  const cleaned = cleanPhone(phone)
  return cleaned.length === 10 && /^[6-9]/.test(cleaned)
}

export function formatPhone(phone: string): string {
  const cleaned = cleanPhone(phone)
  if (!cleaned) return phone
  return `+91 ${cleaned.slice(0, 5)} ${cleaned.slice(5)}`
}

export function normalizeInternationalPhone(countryCode: string, phoneNumber: string): string {
  const code = countryCode.trim()
  const num = phoneNumber.replace(/[^0-9]/g, '')
  return `${code}${num}`
}

export function validateInternationalPhone(phoneNumber: string): boolean {
  const digits = phoneNumber.replace(/[^0-9]/g, '')
  return digits.length >= 10 && digits.length <= 15
}

/** PK storage format for students.phone — digits only, 10–15 length. */
export function validateStudentPhonePk(phone: string): boolean {
  const digits = phone.replace(/\D/g, '')
  return /^[0-9]{10,15}$/.test(digits)
}
